import { SideBarIcon } from 'entities/SideBarIcon'

import StoreIcon from '@mui/icons-material/Store'
import QrCodeIcon from '@mui/icons-material/QrCode2'
import CalendarIcon from '@mui/icons-material/EditCalendar'
import NotificationsIcon from '@mui/icons-material/NotificationsNone'

export const Navigation = () => {
  //   const t = useTranslations()
  return (
    <>
      <SideBarIcon
        routeName="/company"
        // label={t('production.productionList')}
        // TODO: add translations
        label="Company"
        icon={StoreIcon}
      />
      <SideBarIcon
        routeName="/qr_code"
        // label={t('production.productionList')}
        // TODO: add translations
        label="QR Code"
        icon={QrCodeIcon}
      />
      <SideBarIcon
        routeName="/table_reservation"
        // label={t('production.productionList')}
        // TODO: add translations
        label="Table reservation"
        icon={CalendarIcon}
      />
      <SideBarIcon
        routeName="/notifications"
        // label={t('production.productionList')}
        // TODO: add translations
        label="Notifications"
        icon={NotificationsIcon}
      />
      {/* <SideBarIcon
        routeName="/distribution_list"
        // label={t('distribution.distributionList')}
        // TODO: add translations
        label="DIST__LIST"
        icon={PeopleIcon}
      /> */}
    </>
  )
}
